<!-- ========== MAIN ========== -->
<main id="content" role="main">
  <!-- Breadcrumb Section -->

  <!-- Content Section -->
  <div class="bg-light">
    <div class="container space-4">
      <h3 class="text-center">Welcome to {{settings.brand.brandName}}!</h3>
      <h5 class="text-center">Please check your email to finish setting up your account</h5>
    </div>
  </div>
  <!-- End Content Section -->
</main>
<!-- ========== END MAIN ========== -->
